import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from './../../../../shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';;
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';
import { indicadoresVivosModulo } from "../../diccionarios/indicadoresVivosModulo.js"
import { VersionesService } from '../../services/versiones.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { DireccionesUsuariosService } from '../../services/direcciones-usuarios.service';

@Component({
  selector: 'app-reporte-indicadores',
  templateUrl: './reporte-indicadores.component.html',
  styleUrls: ['./reporte-indicadores.component.css']
})
export class ReporteIndicadoresComponent implements OnInit {

  titulo: string = 'Reporte Presupuesto';
  // titulo: string = 'Presupuesto';
  formulario: FormGroup;
  cmbPeriodo: { clave: number; valor: string; }[];
  cmbAnio: { clave: number; valor: string; }[];

  loading: boolean = false;
  listaVacia: boolean = true;

  columnDefs: any[];//aggrid
  defaultColDef: {};//aggrid

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;

  modulo: any = {};
  cmbVersiones: any[] = [];
  filtrosEliminar: boolean = false;
  filtrosVendedor: boolean = false;

  cmbTipoDePresupuesto: any[] = [
    { clave: 1, valor: 'LE-COMERCIAL' },
    { clave: 2, valor: 'LE-COMISIONES' }
  ]

  cmbTipoDeReporte: any[] = [
    { clave: 1, valor: 'Presupuesto'},
    { clave: 2, valor: 'Presupuesto Facturas y Marcas'},
    { clave: 3, valor: 'Presupuesto Jerarquia Materiales'},
  ]

  cmbVendedorComision  : any[] = [];
  cmbClienteComision   : any[] = [];
  rowSeleccionEliminar : any[] = [];
  cmbCanalVenta        : any[] = [];
  cmbGrupoVendedor     : any[] = [];

  constructor(
    private fb          : FormBuilder,
    private _util       : UtilsService,
    private _indicadores: IndicadoresVivosService,
    private _catalogo   : CatalogoIndicadoresService,
    private _versiones  : VersionesService,
    private _dmaestrosApi: DatosMaestrosService,
    private _direcciones: DireccionesUsuariosService,
  ) { }

  ngOnInit() {
    this.formulario = this.fb.group({
      mesInicio   : [,[Validators.required]],
      mesFin      : [,[Validators.required]],
      anio        : [,[Validators.required]],
      version     : [,[Validators.required]],
      tipoReporte : [,[Validators.required]],
      tipoPresupuesto : [,[Validators.required]],
      canal           : [],
      grupoVendedor   : [],
      vendedorInicio  : [],
      vendedorFin     : [],
      clienteInicio   : [],
      clienteFin      : [],
    });
    this.modulo = indicadoresVivosModulo;
    this.cmbPeriodo = this._catalogo.catalogoMeses();
    this.cmbAnio = this._catalogo.catalogoAnio();
    this.cargarGrid();
    this.getAllVersiones();
    this.getVersiones();
  }

  tipoReporteEjecutado : any;
  getReport() {
    this.loading = true;
    this.tipoReporteEjecutado = this.formulario.get('tipoReporte').value;
    this.filtrosEliminar = false;
    let validaCanal :boolean = this.formulario.get('canal').value  == undefined || this.formulario.get('canal').value == null;

    this._indicadores.getReportIndicadores(
      this.formulario.get('anio').value,
      this.formulario.get('mesInicio').value,
      this.formulario.get('mesFin').value,
      this.formulario.get('version').value,
      this.formulario.get('tipoReporte').value,
      this.formulario.get('tipoPresupuesto').value,
      validaCanal ? 0 : this.formulario.get('canal').value,
      this.formulario.get('vendedorInicio').value,
      this.formulario.get('vendedorFin').value,
    ).subscribe((res: any) => {
      // console.log(res);
      this.rowData = res;
      this.listaVacia = this.rowData.length === 0 ? true : false;
      this.loading = false;
      this._util.mensajeOKToast("Registros Encontrados.");
      
      this.getVendedorFiltro();

    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      // console.log(err);
      this._util.mensajeErroToast(err.error.message);
    });

    this.refreshFiltroEliminacion();

  }

  getAllVersiones() {
    this._indicadores.getAllVersionesPresupuesto().subscribe((res: any[]) => {
      this.cmbVersiones = res;
    }, (err) => {
      this.cmbVersiones = [];
    });

    /*
    this._dmaestrosApi.getAllCanalVenta().subscribe((res: any[]) => {
      this.cmbCanalVenta = res.map(e=> {e.dscaCanalVenta = e.idCanalVenta +" - "+e.dscaCanalVenta;  return e;});
    }, (err) => {
      this.cmbCanalVenta = [];
    });
    */

    this._dmaestrosApi.getAllGrupoVendedor().subscribe((res: any[]) => {
      this.cmbGrupoVendedor = res.map(e=> {e.dscaGrupoVendedor = e.idGrupoVendedor +" - "+e.dscaGrupoVendedor;  return e;});

    }, (err) => {
      this.cmbGrupoVendedor = [];
    });

    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this._direcciones.getDireccionesUsuarios().subscribe((res: any[]) => {
      if(res) 
        this.cmbCanalVenta = res.filter(e => e.codigoUsuario == userData.login2);
        res.map(e=> {e.nombreCanalVenta = e.codigoDireccion + " - " + e.nombreCanalVenta;  return e;});

    }, (err) => { this.cmbCanalVenta = []; });

  }

  onQuickFilterChanged() {
    // this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Versión',
        field: 'descripcionVersion',
        filter: true,
        width: 180
      },
      {
        headerName: 'Tipo de presupuesto',
        field: 'descripcionTipoPresupuesto',
        filter: true,
        width: 150
      },
      {
        headerName: 'Año',
        field: 'anio',
        filter: true,
        width: 120
      },
      {
        headerName: 'Mes',
        field: 'mesDescripcion',
        sortable: true,
        width: 160,
        filter: true
      },
      {
        headerName: 'Canal',
        field: 'tipo',
        sortable: true,
        width: 160,
        filter: true
      },
      {
        field: 'sector',
        sortable: true,
        width: 160,
        filter: true
      },
      {
        headerName: 'Cod.Vendedor',
        field: 'codigoVendedor',
        sortable: true,
        width: 150,
        filter: true
      },
      {
        headerName: 'Nom.Vendedor',
        field: 'nombreVendedor',
        sortable: true,
        width: 250,
        filter: true
      },
      {
        headerName: 'Cod.Cliente',
        field: 'codigoCliente',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'Nom.Cliente',
        field: 'nombreCliente',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'Cod.Articulo',
        field: 'codigoArticulo',
        sortable: true,
        filter: true,
        width: 220
      },
      {
        headerName: 'Articulo',
        field: 'nombreArticulo',
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'Cajas',
        field: 'cajas',
        sortable: true,
        width: 180,
        filter: true
      },
      {
        headerName: 'Kilos',
        field: 'kilos',
        sortable: true,
        width: 170,
        filter: true
      },
      {
        headerName: 'Dolares',
        field: 'dolares',
        sortable: true,
        width: 170,
        filter: true
      },
      {
        headerName: 'MTV',
        field: 'mtv',
        sortable: true,
        width: 170,
        filter: true
      },
      {
        headerName: 'Venta bruta',
        field: 'ventaBruta',
        sortable: true,
        width: 170,
        filter: true
      },
      {
        headerName: 'Total marcas',
        field: 'nroMarcas',
        sortable: true,
        width: 170,
        filter: true
      },
      {
        headerName: 'Total facturas',
        field: 'nroFacturas',
        sortable: true,
        width: 170,
        filter: true
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';

    this.defaultColDef = {
      filter: true,
      floatingFilter: true,
    };

  }

  downloadDataCsv() {
    let data: any = [];
    let cabecera: any[];
    let clonData;

    console.log(this.formulario.get('tipoReporte').value);

    if (this.tipoReporteEjecutado == 1){
      data = [];
      cabecera = [['VERSIÓN', 'TIPO REPORTE', 'TIPO PRESUPUESTO', 'ANIO', 'MES', 'VENDEDOR', 'NOM.VENDEDOR', 'CLIENTE', 'NOM.CLIENTE', 'PRODUCTO', 'CONTENEDOR', 'DES.PRODUCTO', 'CAJAS', 'KILOS', 'DOLARES', 'MTV', 'VENTA BRUTA', 'SECTOR']];
      clonData = this.rowData.map((x) => Object.assign({}, x));
      console.log(clonData);
      clonData.forEach((e) => {
        data.push(
          {
            version         : e.descripcionVersion,
            tipo_reporte    : "Presupuesto",
            tipo_presupuesto: e.descripcionTipoPresupuesto,
            anio            : e.anio,
            mesDescripcion  : "'"+e.mesDescripcion,
            codigoVendedor  : e.codigoVendedor,
            nombreVendedor  : e.nombreVendedor,
            codigoCliente   : e.codigoCliente,
            nombreCliente   : e.nombreCliente,
            codigoArticulo  : e.codigoArticulo,
            contenedor      : e.contenedor,
            nombreArticulo  : e.nombreArticulo,
            cajas         : e.cajas,
            kilos         : e.kilos,
            dolares       : e.dolares,
            mtv           : e.mtv,
            venta_bruta   : e.ventaBruta,
            sector        : e.sector,
          }
        );
      });
    }
    else if (this.tipoReporteEjecutado == 2) {
      data = [];
      cabecera = [['VERSIÓN', 'TIPO REPORTE', 'ANIO', 'MES', 'VENDEDOR', 'NOM.VENDEDOR', 'TOTAL MARCAS', 'TOTAL FACTURAS', 'SECTOR']];
      clonData = this.rowData.map((x) => Object.assign({}, x));
      clonData.forEach((e) => {
        data.push(
          {
            version         : e.version,
            tipo_reporte    : "Presupuesto Facturas y Marcas",
            anio            : e.anio,
            mesDescripcion  : "'"+e.mesDescripcion,
            codigoVendedor  : e.codigoVendedor,
            nombreVendedor  : e.nombreVendedor,
            no_marcas       : e.nroMarcas,
            no_facturas     : e.nroFacturas,
            sector          : e.sector,
          }
        );
      });
    } else {
      return;
    }

    let tipoReporteEjecutado = this.tipoReporteEjecutado == 1 ? "General" : "Facturas_Marcas";
    let name: string = "reporte-presupuesto-"+tipoReporteEjecutado+".csv";
    this._util.exportCSV(cabecera, data, name);
    this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  listaDeVersiones: any = [];

  getVersiones() {
    this.loading = true;
    this._versiones.getVersiones().subscribe((res: any[]) => {
      console.log("getVersiones()", res)
      this.loading = false;
      this.listaDeVersiones = res;

      this.listaDeVersiones = res.map(version => {
        return { ...version, detalle: `${version.version} - ${version.nombre}` };
      });
      //this.formulario.get('version').setValue(this.listaDeVersiones.filter(t => t.estado === 'A')[0].id);
    }, (err) => {
      this.loading = false;
      this.listaDeVersiones = [];
    });
  }


  // RTI-TICKET PROCESO DE ELIMINACIÓN EN MASA
  habilitarFiltros(){
    this.filtrosEliminar = !this.filtrosEliminar;
  }

  getVendedorFiltro(){
    console.log("getVendedorFiltro() Establecer combos de Vendedor");
    this.cmbVendedorComision = [];
    this.rowDataTemp = this.rowData;

    this.cmbVendedorComision = this.rowData
    .map(p => ({ vendedor: p.codigoVendedor, nombreVendedor: p.codigoVendedor +" - "+p.nombreVendedor }))
    .filter((value, index, self) =>
      index === self.findIndex((v) => (v.vendedor === value.vendedor))
    );
  }

  refreshFiltroEliminacion(){
    this.formulario.get('clienteInicio').reset();
    this.formulario.get('clienteFin').reset();

    if(!this.filtrosVendedor){
      this.formulario.get('vendedorInicio').reset();
      this.formulario.get('vendedorFin').reset();
    }
  
  }

  eliminarRegistros(){
    let totalRegistros = this.rowData.length;
    this._util.confirmarSincronoPromesaNormal(
      {
        title : "¿Está seguro de la eliminación masiva de "+totalRegistros+" registros.?",
        text  : 'Eliminación Masiva',
        action: "Eliminar",
        funcion: this._indicadores.deleteMasivoPresupuesto(this.rowData),
        loading: true,
        context: this,
      }).then(async (res: any) => {
        await this.delay(2000); // espera 2000 milisegundos (2 segundos) para que muestre el mensaje y después continue con el código
        this.getReport();
    }).catch((err) => {});
  }
  
  public rowDataTemp = this.rowData;
  searchVendor(){
    this.loading = true;
    let filtroVA = parseInt(this.formulario.get('vendedorInicio').value, 10); 
    let filtroVB = parseInt(this.formulario.get('vendedorFin').value, 10);

    if(filtroVA != null && filtroVB != null){
      console.log("filtros por vendedor ", filtroVA, filtroVB);

      this.rowData = this.rowDataTemp.filter(ptpto => {
        let vendedor = parseInt(ptpto.codigoVendedor, 10);
        return vendedor >= filtroVA && vendedor <= filtroVB;
      });

      this.rowData = this.rowData.sort((a, b) => a.codigoCliente - b.codigoCliente);
      this.formulario.get('clienteInicio').reset();
      this.formulario.get('clienteFin').reset();
      this.cmbClienteComision = this.rowData.map(p => ({ cliente: p.codigoCliente, nombreCliente: p.codigoCliente +' - ' + p.nombreCliente }))
      .filter((value, index, self) =>index === self.findIndex((v) => (v.cliente === value.cliente)));
    }
    this.loading = false;
  }

  searchCliente(){
    this.loading = true;
    let filtroVA = parseInt(this.formulario.get('vendedorInicio').value, 10); 
    let filtroVB = parseInt(this.formulario.get('vendedorFin').value, 10);
    let filtroCA = parseInt(this.formulario.get('clienteInicio').value, 10);
    let filtroCB = parseInt(this.formulario.get('clienteFin').value, 10);

    if(!isNaN(filtroCA) && !isNaN(filtroCB)){
      console.log("*Filtro por cliente ", filtroCA + " " + filtroCB);
      this.rowData = this.rowDataTemp.filter(ptpto => {
        let cliente = parseInt(ptpto.codigoCliente, 10);
        let vendedor = parseInt(ptpto.codigoVendedor, 10);
        return (vendedor >= filtroVA && vendedor <= filtroVB) && (cliente >= filtroCA && cliente <= filtroCB);
      });
    }
    this.loading = false;
  }


  // Función de delay
  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  versionesFiltrables= [];
  searchAnioPresupuesto(){
    let filtroAnio = this.formulario.get('anio').value; 
    this.versionesFiltrables = this.listaDeVersiones.filter(t => t.estado === 'A');

    if(!isNaN(filtroAnio)){
      console.log("*Filtro presupuesto por anio ", filtroAnio);
      this.versionesFiltrables = this.listaDeVersiones.filter(ptpto => (ptpto.anio === filtroAnio));
    }

  }

  searchVendedor(){
    //this.formulario.get('vendedorFin').updateValueAndValidity();
    
    this.cmbVendedorComision  = [];
    this.filtrosVendedor      = true;    
    let filtroGrupoVendedor   = this.formulario.get('grupoVendedor').value;
    this.formulario.get('vendedorInicio').setValidators([Validators.required]);
    this.formulario.get('vendedorFin').setValidators([Validators.required]);

    this._dmaestrosApi.getVendedorByGrupo(filtroGrupoVendedor).subscribe((res: any[]) => {
      this.cmbVendedorComision = res.map(v => {
        return { ...v, nombreVendedor: `${v.idVendedor} - ${v.nombreVendedor1}` , vendedor: v.idVendedor};
      });
      });
  }

}
